"use strict";

(function () {
  'use strict';

  angular.module('utils-service', []).service('UtilsService', UtilsService);
  UtilsService.$inject = ['localStorageService', '$http', '$q'];

  function UtilsService(localStorageService, $http, $q) {
    var Storage = {};

    Storage.checkStorageSupport = function (callback) {
      if (!localStorageService.isSupported) {
        callback('Cookies are not enabled on your browser. Please enable cookies in your browser preferences to continue.');
      } else {
        callback(null);
      }
    }; //=======================================================


    var isNumber = function isNumber(n) {
      if (n === '' || n == null) return false;
      n = n.replace(/[,]/g, ''); // just remove the Comma from FormatNumber to check for valid number

      return !isNaN(parseFloat(n)) && isFinite(n);
    }; //=======================================================


    var Form = {};

    Form.isValid = function (form) {
      return form.$valid;
    };

    Form.validateForm = function (form) {
      angular.forEach(form.$error, function (field) {
        angular.forEach(field, function (errorField) {
          if (errorField && errorField.hasOwnProperty('$setTouched')) errorField.$setTouched();
        });
      });
    }; //=======================================================


    var Recaptcha = {};

    Recaptcha.validate = function (response) {
      var deferred = $q.defer();
      $http.post('/utils/recaptcha/validate', {
        response: response
      }).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    return {
      Storage: Storage,
      Form: Form,
      isNumber: isNumber,
      Recaptcha: Recaptcha
    };
  }
})();